:host {
  display: block;
}

$onlyDesktop: min-width":" 768px;

@mixin basic-hamburger ($width, $height, $top) {
  position: absolute;
  width: $width;
  min-width: $width;
  height: $height;
  min-height: $height;
  background: var(--color-nero);
  transition-duration: 0.5s;
  left: 0;
  top: $top;
}

.hamburger {
  position: relative;
  min-width: 20px;
  min-height: 20px;
  transition-duration: 0.5s;
  cursor: pointer;

  @media ($onlyDesktop) {
    min-width: 27px;
    min-height: 27px;
    flex: 0 0 27px;
  }

  span {
    @include basic-hamburger(20px, 3px, 50%);
    transform: translateY(-50%);

    @media ($onlyDesktop) {
      @include basic-hamburger(27px, 4px, 50%);
    }
    
    &:before {
      content: '';
      @include basic-hamburger(20px, 3px, -8px);

      @media ($onlyDesktop) {
        @include basic-hamburger(27px, 4px, -10px);
      }
    }
    
    &:after {
      content: '';
      @include basic-hamburger(20px, 3px, 8px);

      @media ($onlyDesktop) {
        @include basic-hamburger(27px, 4px, 10px);
      }
    }
  }

  &.open {
    span {
      visibility: hidden;
      transition-duration: 0.0s;

      &:before {
        content: '';
        transition-duration: 0.5s;
        top: 0px;
        visibility: visible;
        transform: rotateZ(-45deg);
      }
      
      &:after {
        content: '';
        transition-duration: 0.5s;
        top: 0px;
        visibility: visible;
        transform: rotateZ(45deg);
      }
    }
  }
}
